import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = true
}: CardProps) {
  return <div className={`
        bg-white rounded-xl border border-gray-100 overflow-hidden
        ${hoverEffect ? 'hover:shadow-xl hover:-translate-y-1 transition-all duration-300' : 'shadow-sm'}
        shadow-md
        ${className}
      `} data-id="element-45">
      {children}
    </div>;
}